<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2b" id="ill"><a id="page_ix"></a>Illustrations</h2>
<p class="tocfig"><a href="#/xhtml/chapter2#fig1">“Fly before you buy” sequential development</a></p>
<p class="tocfig"><a href="#/xhtml/chapter2#fig2">Weapon System Project Office’s system concept</a></p>
<p class="tocfig"><a href="#/xhtml/chapter2#fig3">Organization of the Inglewood complex</a></p>
<p class="tocfig"><a href="#/xhtml/chapter2#fig4">Pre-Gillette organization of ballistic missile development</a></p>
<p class="tocfig"><a href="#/xhtml/chapter2#fig5">Ballistic missile organization—Gillette Procedures</a></p>
<p class="tocfig"><a href="#/xhtml/chapter2#fig6">Concurrency</a></p>
<p class="tocfig"><span href="#/xhtml/chapter3#fig7" title="Link target outside of Sample">Brigadier General Bernard Schriever and Dr. Simon Ramo</span></p>
<p class="tocfig"><span href="#/xhtml/chapter3#fig8" title="Link target outside of Sample"><em>Atlas D launch</em></span></p>
<p class="tocfig"><span href="#/xhtml/chapter3#fig9" title="Link target outside of Sample">Ballistic Systems Division organization network</span></p>
<p class="tocfig"><span href="#/xhtml/chapter3#fig10" title="Link target outside of Sample">Systems management phases</span></p>
<p class="tocfig"><span href="#/xhtml/chapter3#fig11" title="Link target outside of Sample">Traditional line organization and lines of communication</span></p>
<p class="tocfig"><span href="#/xhtml/chapter3#fig12" title="Link target outside of Sample">Matrix organization</span></p>
<p class="tocfig"><span href="#/xhtml/chapter4#fig13" title="Link target outside of Sample"><em>Mariner Venus 1962</em></span></p>
<p class="tocfig"><span href="#/xhtml/chapter4#fig14" title="Link target outside of Sample"><em>Ranger</em> spacecraft</span></p>
<p class="tocfig"><span href="#/xhtml/chapter4#fig15" title="Link target outside of Sample">Typical profile of engineering changes for spacecraft project</span></p>
<p class="tocfig"><span href="#/xhtml/chapter5#fig16" title="Link target outside of Sample">Mercury-Atlas organization</span></p>
<p class="tocfig"><span href="#/xhtml/chapter5#fig17" title="Link target outside of Sample">George Mueller’s “five box” structure</span></p>
<p class="tocfig"><span href="#/xhtml/chapter5#fig18" title="Link target outside of Sample">George Mueller and Samuel Phillips</span></p>
<p class="tocfig"><span href="#/xhtml/chapter5#fig19" title="Link target outside of Sample">Phillips’s review processes for Apollo</span></p>
<p class="tocfig"><span href="#/xhtml/chapter5#fig20" title="Link target outside of Sample">Apollo with its major contractors identified</span></p>
<p class="tocfig"><span href="#/xhtml/chapter7#fig21" title="Link target outside of Sample"><em>HEOS</em> spacecraft</span></p>
<p class="tocfig"><span href="#/xhtml/chapter7#fig22" title="Link target outside of Sample">Hoernke’s analogy of engineering and project control</span></p>
<p class="tocfig"><span href="#/xhtml/chapter7#fig23" title="Link target outside of Sample">The ESRO Planning, Management, and Control System</span></p>
<p class="tocfig"><span href="#/xhtml/chapter8#fig24" title="Link target outside of Sample">Cold War social groups and alliances</span></p>
<p class="tocfig"><span href="#/xhtml/chapter8#fig25" title="Link target outside of Sample">Authority changes at NASA and ESRO</span></p>
<p class="tocfig"><span href="#/xhtml/chapter8#fig26" title="Link target outside of Sample">Systems management methods classified by social group</span><a id="page_x"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ill.vue?40830350